import KnowledgeDocument from "pages/Admin/Agents/KnowledgeDocument";

export default function KnowledgeDocumentPage() {
  return <KnowledgeDocument />;
}
